import { Component, Input, OnInit } from '@angular/core';
import { FilesService } from 'src/app/services/files.service';
const dicomdirFileName = 'DICOMDIR';
@Component({
  selector: 'app-medical-studies-list',
  templateUrl: './medical-studies-list.component.html',
  styleUrls: ['./medical-studies-list.component.scss'],
})
export class MedicalStudiesListComponent implements OnInit {
  medicalStudies = [];
  constructor(private files_$: FilesService) { }

  displayedColumns: string[] = ['fileDesc', 'uploadedDate'];
  ngOnInit(): void {
    this.files_$.filesArray.subscribe((files: any) => {
      this.medicalStudies = files.filter((file: any) => file.name === dicomdirFileName);
    });
  }
}
